<app-form-builder [fieldDetails]="widgetFields" (actionEvents)="actionHandler($event)" #createLineForm></app-form-builder>


